import { Component, Vue, Prop } from "vue-property-decorator";
import Change from '@/components/change/index.vue';
import Userinfo from '@/components/userinfo/index.vue';

import user_module from "@/modules/user/index";
import history_module from "@/modules/history";
import Loader from "@/components/loader/Loader.vue";


interface Link {
  id: string,
  name: string, 
  to: string
}

interface LinkWithActive extends Link{
  active: boolean
}

@Component({

  components: {
    Change,
    Userinfo,
    Loader
  }

})
  
export default class Usermenu extends Vue {

  @Prop({ default: "userinfo" }) id!: String;
  
  invalidHeaderText: string = 'Invalid Access Details';
  invalidContentText: string = 'Wrong username/password or your account/account password has expired. Please check your credentials or contact us at 800-282-4567, clientsuccess@rixtrema.com';
  openedInvalidModal: boolean = false;

  links: Link[] = [
  
    {
      name: 'CHANGE PASSWORD',
      to: '/change',
      id: 'change'
    }
  ]

  get settings(){
    return user_module.settings;
  }

  closeInvalidModal(){

    this.openedInvalidModal = false;
  }

  changePage(id: string){

    this.$router.push({ query: { id }})
  }

  back() {

    this.$router.push(history_module.prev || '/');

  }

  signout(){

    user_module.logout()
    this.$router.push('/login');
  }

  get email(){

    return user_module?.userInfo?.Email

  }

  get linksWithActive(): LinkWithActive[] {

    return this.links.map(link => {

      return {
        ...link,
        active: link.id === this.id
      }
    })

  }

  mounted(){

    console.log('referrer', this.$router);
  }

}

